import styled from "@emotion/styled";
import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({bredData}:any) => {
  return (
    <div>
      <ul className="breadcrumb">
        {
            bredData.map((item:any, index:any) => {
              return (
                <li key={index}>
                  <Link to={item.link} className={item.active ? "active-bread" : ''}>{item.title}</Link>
                </li>
              )
            })
        }
        {/* <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#">Pictures</a>
        </li>
        <li>
          <a href="#">Summer 15</a>
        </li>
        <li>Italy</li> */}
      </ul>
    </div>
  );
};

export default Breadcrumb;
